import React from "react";

export default function Precios() {
  return <div>Precios</div>;
}
